<template>
   <div class="modal-view-c" v-if="ModalStatus">
      <div class="modal-view-inner-wrapper">
         <section class="modal-view-header">
            <div class="popup-close-btn" @click="handlerClosePopup"></div>
         </section>

         <section class="modal-view-body"><slot></slot></section>
      </div>
   </div>
</template>

<script>
export default {
   name: "ModalView",
   data() {
      return {
         modalStatus: true,
      };
   },
   methods: {
      handlerClosePopup() {
         this.$store.commit("app/setModalViewStatus", { status: false, paymentRequired: false });
         window.location.reload();
      },
   },
   computed: {
      ModalStatus() {
         return this.$store.state.app.modalViewStatus.status;
      },
   },
};
</script>

<style lang="scss" scoped>
.modal-view-c {
   position: fixed;
   /* background-color: rgba(0, 0, 0, 0.5); */
   background-color: var(--background-overlay);
   inset: 0;
   width: 100%;
   height: 100%;
   z-index: 999;
   display: flex;
   align-items: center;
   justify-content: center;
}

.modal-view-inner-wrapper {
   position: relative;
   background-color: var(--container-bg);
   /* box-shadow: var(--gray-800-alpha-75) 0px 2px 5px -1px, var(--gray-1000-alpha-75) 0px 4px 8px -1px; */
   box-shadow: var(--gts-box-shadow);
   border: 1px solid var(--gray-200);
   padding: 3.5rem 2rem;
   border-radius: 1rem;

   width: 40%;
   height: fit-content;
   @media (max-width: 576px) {
      width: 96%;
   }
   @media (max-width: 768px) {
      width: 90%;
   }
   @media (max-width: 1200px) {
      width: 90%;
   }
}
.popup-close-btn {
   width: 42px;
   height: 42px;
   border: 1px solid var(--gray-50);
   position: absolute;
   right: 2rem;
   top: 1.25rem;
   cursor: pointer;

   &::before,
   &::after {
      opacity: 0.75;
      content: "";
      width: 2.5px;
      height: 24px;
      display: block;
      border-radius: 0.5rem;
      background-color: var(--gray-800);
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      top: 0;
      margin: auto;
   }

   &::before {
      transform: rotate(45deg);
   }
   &::after {
      transform: rotate(-45deg);
   }
}
</style>
